import { IBar, IDoPos, IPitch, IScore, TClef } from "../../../../../common/types";
import { lineDistance } from "../parameters";
import { IAccidental } from "../utils";

interface IProps {
    score: IScore,
    accidentals: IAccidental[],
}

export const getPitchPositions = ({ score, accidentals }: IProps) => {
    let pitchPositions: (number[] | null)[][][] = [[], [], [], [], [], []];
    let maxPitch = [0, 0, 0, 0, 0, 0];
    let minPitch = [0, 0, 0, 0, 0, 0];
    [0, 1, 2, 3, 4, 5].forEach(voice => {
        let doPos = score.doPos;
        const doClefOffset = score.doClef ? (score.doClefOffset || [])[voice] || 0 : 0;
        const bars = score["bars" + (voice || "")] as IBar[];
        if (!bars) return;
        const clef = score["clef" + (voice || "")] || "treble" as TClef;
        bars.forEach((bar, barIndex) => {
            doPos = accidentals[barIndex];
            pitchPositions[voice].push([]);
            if (bar === null) return;
            bar.notes.forEach((note) => {
                let p: null | number[] = [0];
                if (note.r || !note.p) {
                    p = null;
                } else {
                    if (Array.isArray(note.p)) {
                        p = note.p.map(pitch => {
                            return getAbsolutePosition(pitch, clef, doPos, score["octave" + voice] || 0) - doClefOffset;
                        });
                        maxPitch[voice] = Math.max(maxPitch[voice], p[p.length - 1]);
                        minPitch[voice] = Math.min(minPitch[voice], p[0]);
                    } else {
                        p = [getAbsolutePosition(note.p, clef, doPos, score["octave" + voice] || 0) - doClefOffset];
                        maxPitch[voice] = Math.max(maxPitch[voice], p[0]);
                        minPitch[voice] = Math.min(minPitch[voice], p[0]);
                    }
                }
                pitchPositions[voice][pitchPositions[voice].length - 1].push(p);
            });
        });
    });
    return {
        maxPitch,
        minPitch,
        pitchPositions,
    };
};

export const getAbsolutePosition = (p: IPitch, clef: TClef, doPos: IDoPos, octave: number) => {
    let rn = solfaParser[p.s] + (p.o || 0) * 7 + (((doPos.i + 14) * 4) % 7) + (doPos.o + octave) * 7;
    let clefDistance = clefTypes[clef] + 28;
    let notePos = clefDistance - rn;
    return notePos;
};

const clefTypes = {
    treble: 6,
    "treble-octave": -1,
    bass: -6,
};

const solfaParser = [3, 0, 4, 1, 5, 2, 6];

export const getPaddingBottomExtra = (max: number) => {
    let paddingBottomExtra = 0;
    if (max > 5) {
        paddingBottomExtra = (max - 5) * (lineDistance / 2);
    }
    return paddingBottomExtra;
};

export const getPaddingTopExtra = (min: number) => {
    let paddingTopExtra = 0;
    if (min < -5) {
        paddingTopExtra = Math.abs(min + 5) * (lineDistance * 0.4);
    }
    return paddingTopExtra;
};
